import { isAiBriefAvailable } from '@fiverr-private/ai_brief';
import { GigData } from '../../server/types/GigData';
import { useRelevantGigs } from './useRelevantGigs';

export const useBriefAiAvailablity = (gigs: GigData[] = [] as GigData[]) => {
    const relevantGigs = useRelevantGigs(gigs);
    return !!relevantGigs?.length && isAiBriefAvailable();
};
